/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { ChangeRequestStatusRequest } from '../models/ChangeRequestStatusRequest';
import type { GetAllAccessibleRequestsRequest } from '../models/GetAllAccessibleRequestsRequest';
import type { GetAllAccessibleRequestsResponse } from '../models/GetAllAccessibleRequestsResponse';
import type { GetPaymentRequestDetailsResponse } from '../models/GetPaymentRequestDetailsResponse';
import type { GetReimbursementEventLogsResponse } from '../models/GetReimbursementEventLogsResponse';
import type { GetStipendEventLogsResponse } from '../models/GetStipendEventLogsResponse';
import type { GetTravelEventLogsResponse } from '../models/GetTravelEventLogsResponse';
import type { GetTravelRequestDetailsResponse } from '../models/GetTravelRequestDetailsResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class RequestControllerv2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns number
     * @throws ApiError
     */
    public requestControllerv2GetSubmittedRequestsCount(): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/requests/submitted/count',
        });
    }
    /**
     * @param requestBody
     * @returns GetAllAccessibleRequestsResponse
     * @throws ApiError
     */
    public requestControllerv2GetAllAccessibleRequests(
        requestBody: GetAllAccessibleRequestsRequest,
    ): Observable<GetAllAccessibleRequestsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/requests/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns number
     * @throws ApiError
     */
    public requestControllerv2ChangeRequestStatus(
        requestBody: ChangeRequestStatusRequest,
    ): Observable<number> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/requests/change-status',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestType
     * @param requestId
     * @returns GetPaymentRequestDetailsResponse
     * @throws ApiError
     */
    public requestControllerv2GetPaymentRequestDetails(
        requestType: string,
        requestId: number,
    ): Observable<GetPaymentRequestDetailsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/requests/payment-details/{requestType}/{requestId}',
            path: {
                'requestType': requestType,
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @returns GetTravelRequestDetailsResponse
     * @throws ApiError
     */
    public requestControllerv2GetTravelRequestDetails(
        requestId: number,
    ): Observable<GetTravelRequestDetailsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/requests/travel-details/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @returns GetReimbursementEventLogsResponse
     * @throws ApiError
     */
    public requestControllerv2GetReimbursementEventLogs(
        requestId: number,
    ): Observable<GetReimbursementEventLogsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/requests/logs/reimbursement/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @returns GetStipendEventLogsResponse
     * @throws ApiError
     */
    public requestControllerv2GetStipendEventLogs(
        requestId: number,
    ): Observable<GetStipendEventLogsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/requests/logs/stipend/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
    /**
     * @param requestId
     * @returns GetTravelEventLogsResponse
     * @throws ApiError
     */
    public requestControllerv2GetTravelEventLogs(
        requestId: number,
    ): Observable<GetTravelEventLogsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/requests/logs/travel/{requestId}',
            path: {
                'requestId': requestId,
            },
        });
    }
}
